import { useContext, useEffect, useState } from "react";
import { Veiculo } from "../shared/types";
import { CardVeiculo } from "../components/cardVeiculo";
import { AuthContext } from "../shared/context/auth";
import ObrigadoImg from '../assets/img-obrigado.png';

export const Obrigado = () => {

    const { estoque } = useContext(AuthContext);
    const [propaganda, setPropaganda] = useState<Veiculo[]>([]);

    const handlePropaganda = () => {
        const listaEmbaralhada = [...estoque].sort(() => Math.random() - 0.5);
        const itensAleatorios = listaEmbaralhada.slice(0, 4);
        setPropaganda(itensAleatorios);
    }

    useEffect(() => {
        handlePropaganda()
    },[estoque])

    return (
        <div className="min-h-screen bg-[#191919] flex flex-col items-center py-9">
            <div className="max-w-[1600px] flex flex-col items-center px-2 w-full">
                <div className="flex justify-between gap-10 items-center max-w-[1300px] mobile:flex-col w-full">
                    <div className="flex flex-col gap-5 flex-1 text-white">
                        <h1 className="max-w-[500px]">Obrigado pelo seu interesse!</h1>
                        <h1 className="max-w-[500px]">Recebemos sua mensagem com sucesso e já estamos cuidando dela com atenção. Em breve, um dos nossos consultores entrará em contato para continuar o atendimento e tirar todas as suas dúvidas.</h1>
                        <h1 className="max-w-[500px]">Fique à vontade para explorar mais opções em nosso site enquanto isso!</h1>
                    </div>
                    <img className="flex-1 max-w-[570px] mobile:max-w-[80vw]" src={ObrigadoImg} alt="Agradecimentos" />
                </div>
                <div className="flex flex-col gap-5">
                    {/* Outras opções */}
                    <div>
                        <div className="flex flex-row gap-4 items-center">
                            <h1 className="whitespace-nowrap text-white">VEJA OUTRAS OPÇÕES</h1>
                            <hr className="h-0.5 bg-accent w-full" />
                        </div>
                    </div>

                    <div className="grid grid-cols-4 gap-11 mobile:grid-cols-1 mobile:gap-5">
                        {propaganda.map((x) => (
                            <CardVeiculo key={x.cod_veiculo} veiculo={x} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}